var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2Dkxdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.411 22.1491L28.8538 21.8742C28.6809 21.7651 28.5411 21.6041 28.4642 21.4025L28.4222 21.292C28.4125 21.2663 28.4054 21.2407 28.3981 21.2148L28.1213 21.3867L28.411 22.1491Z",
    fill: "#2254D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7425 21.9729L30.7259 21.623C31.1546 21.4705 31.4207 21.0556 31.3717 20.6168L31.3431 20.3615C31.3075 20.044 31.0119 19.8149 30.6835 19.85L29.247 20.0036C28.6043 20.0724 28.1988 20.7057 28.4223 21.292L28.4643 21.4025C28.6543 21.9009 29.2267 22.1564 29.7425 21.9729Z",
    fill: "#5388EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61074 22.1489L6.16789 21.8739C6.3408 21.7648 6.48065 21.6038 6.5575 21.4022L6.59951 21.2917C6.60928 21.2661 6.61628 21.2404 6.62361 21.2146L6.90039 21.3865L6.61074 22.1489Z",
    fill: "#2254D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27921 21.9726L4.29586 21.6228C3.86714 21.4702 3.60098 21.0554 3.65001 20.6165L3.67868 20.3613C3.71419 20.0438 4.00983 19.8146 4.33821 19.8497L5.77472 20.0034C6.41747 20.0721 6.8229 20.7055 6.59941 21.2918L6.55739 21.4022C6.36746 21.9007 5.79508 22.1561 5.27921 21.9726Z",
    fill: "#5388EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06496 32.7458C6.35656 32.7458 5.72048 32.4527 5.27417 31.9873V34.0581C5.27417 34.5377 5.6765 34.9263 6.17266 34.9263H8.86828C9.3646 34.9263 9.76677 34.5375 9.76677 34.0581V32.7458H7.06496Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9146 32.7454H25.2126V34.0579C25.2126 34.5375 25.615 34.9261 26.1111 34.9261H28.8068C29.3031 34.9261 29.7053 34.5373 29.7053 34.0579V31.9868C29.2591 32.4524 28.623 32.7454 27.9146 32.7454Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0649 32.7458L27.9145 32.7455C29.2639 32.7455 30.3578 31.6884 30.3578 30.3846V26.0954C30.3578 25.4811 30.1718 24.8802 29.8226 24.3668L28.534 22.4719H6.44543L5.15683 24.3668C4.8076 24.8802 4.62158 25.4811 4.62158 26.0954V30.3848C4.62142 31.6887 5.71537 32.7458 7.0649 32.7458Z",
    fill: "#5388EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3577 26.0956C30.3577 25.4813 30.1717 24.8804 29.8225 24.367L28.5339 22.4722H28.2547L29.0082 23.58C29.3574 24.0935 29.5434 24.6944 29.5434 25.3087V29.5979C29.5434 30.9017 28.4495 31.9588 27.1001 31.9588L6.2505 31.9591C5.78465 31.9591 5.35088 31.8308 4.98047 31.6123C5.40951 32.2913 6.18128 32.746 7.06494 32.746L27.9146 32.7457C29.2639 32.7457 30.3579 31.6887 30.3579 30.3848L30.3577 26.0956Z",
    fill: "#2254D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0699 29.2951H13.909C13.5393 29.2951 13.2158 29.0543 13.1215 28.7088L12.7366 27.2983C12.6004 26.7992 12.9899 26.3107 13.5241 26.3107H21.4548C21.9889 26.3107 22.3785 26.7992 22.2424 27.2983L21.8575 28.7088C21.7632 29.0543 21.4398 29.2951 21.0699 29.2951Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2566 23.3966L27.8127 22.6326C27.7551 22.5333 27.6464 22.4719 27.5286 22.4719H7.45047C7.3327 22.4719 7.22406 22.5333 7.1664 22.6326L6.72253 23.3966C6.47559 23.8216 6.68376 24.359 7.15874 24.5229L10.5453 25.6917C10.7211 25.7524 10.9065 25.7834 11.0931 25.7834H23.8857C24.0723 25.7834 24.2577 25.7524 24.4335 25.6917L27.8201 24.5229C28.2954 24.359 28.5035 23.8216 28.2566 23.3966Z",
    fill: "#2254D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1166 26.9688C24.7586 26.3563 26.2241 25.3781 29.0639 25.3298C29.2012 25.3274 29.3258 25.4107 29.374 25.535C29.552 25.9946 29.8405 27.0825 28.733 27.3798C27.6834 27.6615 25.4228 27.5672 24.3245 27.4997C24.0471 27.4826 23.9189 27.1574 24.1166 26.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3741 25.535C29.3259 25.4108 29.2013 25.3274 29.064 25.3298C28.9698 25.3313 28.8811 25.3365 28.7898 25.3402C28.8765 25.8436 28.8021 26.4642 28.0067 26.6778C27.14 26.9104 25.449 26.8867 24.267 26.8333C24.213 26.8799 24.1622 26.9255 24.1166 26.969C23.9189 27.1575 24.0472 27.4827 24.3244 27.4997C25.423 27.5672 27.6834 27.6617 28.733 27.3798C29.8406 27.0825 29.5522 25.9946 29.3741 25.535Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8624 26.9688C10.2205 26.3563 8.75496 25.3781 5.91518 25.3298C5.77786 25.3274 5.65325 25.4107 5.60504 25.535C5.427 25.9946 5.13853 27.0825 6.246 27.3798C7.29565 27.6615 9.5562 27.5672 10.6546 27.4997C10.932 27.4826 11.0601 27.1574 10.8624 26.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8624 26.9688C10.704 26.8177 10.4949 26.6443 10.2279 26.468C10.2369 26.6271 10.1196 26.7858 9.92821 26.7976C8.82969 26.8651 6.5693 26.9595 5.51965 26.6777C5.50173 26.6729 5.48724 26.6662 5.46997 26.661C5.54767 26.9721 5.76496 27.2506 6.24597 27.3796C7.29561 27.6614 9.55617 27.5671 10.6545 27.4996C10.9319 27.4826 11.0601 27.1574 10.8624 26.9688Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5263 15.2819H11.4532C10.0872 15.2819 8.86639 16.1052 8.39532 17.3442L6.44556 22.472H28.5341L26.5843 17.3442C26.1131 16.1053 24.8922 15.2819 23.5263 15.2819Z",
    fill: "#5388EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69721 21.1162L9.07654 17.5504C9.31452 16.9353 9.92274 16.5275 10.6023 16.5275H24.3769C25.0565 16.5275 25.6647 16.9353 25.9027 17.5504L27.282 21.1162C27.3616 21.3219 27.2041 21.5412 26.9769 21.5412H8.00229C7.77507 21.5412 7.61755 21.3219 7.69721 21.1162Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7678 17.7865C18.5879 17.7865 18.4366 17.6455 18.4366 17.4718C18.4366 17.298 18.577 17.157 18.757 17.157H18.7678C18.9476 17.157 19.0935 17.298 19.0935 17.4718C19.0935 17.6455 18.9478 17.7865 18.7678 17.7865ZM17.4539 17.7865H10.6126C10.4328 17.7865 10.2869 17.6455 10.2869 17.4718C10.2869 17.298 10.4328 17.157 10.6126 17.157H17.4539C17.6337 17.157 17.7797 17.298 17.7797 17.4718C17.7797 17.6455 17.6337 17.7865 17.4539 17.7865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.282 21.1163L25.9027 17.5504C25.6779 16.9692 25.1224 16.5736 24.4885 16.5316L25.653 19.5423C25.7326 19.7481 25.5751 19.9673 25.3479 19.9673H8.14156L7.69721 21.1163C7.61755 21.322 7.77507 21.5412 8.00229 21.5412H26.9767C27.2041 21.5412 27.3615 21.322 27.282 21.1163Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.282 21.1162L25.9027 17.5503C25.7474 17.1491 25.4342 16.837 25.0469 16.6678C25.0615 16.6992 25.0757 16.7308 25.0882 16.7634L26.4676 20.3292C26.5472 20.5349 26.3897 20.7542 26.1625 20.7542H7.83729L7.69721 21.1162C7.61755 21.3219 7.77507 21.5411 8.00229 21.5411H26.9767C27.2041 21.5411 27.3615 21.3219 27.282 21.1162Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4144 31.4856H9.56491C9.28931 31.4856 9.13831 31.1755 9.31374 30.9703L9.76917 30.4376C9.92392 30.2566 10.1541 30.152 10.3971 30.152H24.5823C24.8252 30.152 25.0555 30.2568 25.2103 30.4376L25.6657 30.9703C25.841 31.1757 25.6898 31.4856 25.4144 31.4856Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4914 31.7313C28.0127 31.7313 28.4353 31.3228 28.4353 30.8189C28.4353 30.315 28.0127 29.9065 27.4914 29.9065C26.9702 29.9065 26.5476 30.315 26.5476 30.8189C26.5476 31.3228 26.9702 31.7313 27.4914 31.7313Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4916 31.3743C27.8089 31.3743 28.0661 31.1256 28.0661 30.8189C28.0661 30.5121 27.8089 30.2634 27.4916 30.2634C27.1742 30.2634 26.917 30.5121 26.917 30.8189C26.917 31.1256 27.1742 31.3743 27.4916 31.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.044 14.371L12.2495 21.2928H24.8279L27.3228 17.8319C20.8726 17.5242 19.044 14.371 19.044 14.371Z",
    fill: "url(#paint0_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9108 5.55554H20.8892C19.8213 5.55554 18.9556 6.41564 18.9556 7.47665V15.9121C18.9556 16.9732 19.8213 17.8333 20.8892 17.8333H32.9108C33.9787 17.8333 34.8445 16.9732 34.8445 15.9121V7.47665C34.8445 6.41564 33.9787 5.55554 32.9108 5.55554Z",
    fill: "url(#paint1_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5205 10.967C24.2426 10.967 24.8281 10.3853 24.8281 9.66784C24.8281 8.95038 24.2426 8.36877 23.5205 8.36877C22.7983 8.36877 22.2129 8.95038 22.2129 9.66784C22.2129 10.3853 22.7983 10.967 23.5205 10.967Z",
    fill: "url(#paint2_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5204 11.6725C22.1414 11.6725 21.0234 12.7831 21.0234 14.1532C21.0234 14.3489 21.1831 14.5076 21.3801 14.5076H25.6605C25.8576 14.5076 26.0172 14.3489 26.0172 14.1532C26.0173 12.7831 24.8994 11.6725 23.5204 11.6725Z",
    fill: "url(#paint3_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1962 9.74726H27.7826C27.4024 9.74726 27.0942 9.44111 27.0942 9.06339C27.0942 8.68567 27.4024 8.37952 27.7826 8.37952H32.1962C32.5763 8.37952 32.8849 8.68567 32.8849 9.06339C32.8849 9.44111 32.5763 9.74726 32.1962 9.74726Z",
    fill: "url(#paint4_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1962 12.1817H27.7826C27.4024 12.1817 27.0942 11.8756 27.0942 11.4978C27.0942 11.1201 27.4024 10.814 27.7826 10.814H32.1962C32.5763 10.814 32.8849 11.1201 32.8849 11.4978C32.8849 11.8756 32.5763 12.1817 32.1962 12.1817Z",
    fill: "url(#paint5_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1962 14.5117H27.7826C27.4024 14.5117 27.0942 14.2055 27.0942 13.8278C27.0942 13.4501 27.4024 13.1439 27.7826 13.1439H32.1962C32.5763 13.1439 32.8849 13.4501 32.8849 13.8278C32.8849 14.2055 32.5763 14.5117 32.1962 14.5117Z",
    fill: "url(#paint6_linear_1081_1387)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.0635 5.5708C33.0676 5.62179 33.0789 5.67061 33.0789 5.72268C33.0789 11.4425 28.4118 16.0794 22.6546 16.0794H19.1238C19.0714 16.0794 19.0222 16.0681 18.9709 16.064C19.0501 17.0528 19.8736 17.8333 20.8892 17.8333H32.9106C33.9786 17.8333 34.8444 16.9731 34.8444 15.9121V7.4766C34.8444 6.46766 34.0587 5.64945 33.0635 5.5708Z",
    fill: "url(#paint7_linear_1081_1387)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1081_1387",
    x1: 19.9572,
    y1: 19.0496,
    x2: 21.8032,
    y2: 13.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#197BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1081_1387",
    x1: 18.9556,
    y1: 11.6944,
    x2: 34.8445,
    y2: 11.6944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1081_1387",
    x1: 22.2129,
    y1: 9.66791,
    x2: 24.8281,
    y2: 9.66791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9374C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1081_1387",
    x1: 21.0233,
    y1: 13.0898,
    x2: 26.0175,
    y2: 13.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9374C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1081_1387",
    x1: 27.0942,
    y1: 9.06332,
    x2: 32.8849,
    y2: 9.06332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1081_1387",
    x1: 27.0942,
    y1: 11.498,
    x2: 32.8849,
    y2: 11.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1081_1387",
    x1: 27.0942,
    y1: 13.8279,
    x2: 32.8849,
    y2: 13.8279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F6C7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A465B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1081_1387",
    x1: 18.9707,
    y1: 11.7023,
    x2: 34.8444,
    y2: 11.7023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4C829"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6667,
    height: 34.6667,
    fill: "white",
    transform: "translate(3.06665 2.66663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Dkxdk);
export default __webpack_public_path__ + "static/media/L2dkxdk.a1b2321f36458c6a65b01401e96c3141.svg";
export { ForwardRef as ReactComponent };